export class REGISTER_USER {
  static TABLE_HEAD = [
    { id: 'row', label: '' },
    { id: 'userId', label: 'userId' },
    { id: 'email', label: 'email' },
    { id: 'username', label: 'username' },
    { id: 'nickname', label: 'nickname' },
    { id: 'title', label: 'title' },
    { id: 'userType', label: 'userType' },
    { id: 'authCode', label: 'authCode' },
    { id: 'registerDate', label: 'registerDate' },
    { id: 'history', label: 'history' },
    { id: 'moreMenu', label: '' }
  ];

  static USER_TYPE = ['person', 'group', 'bot', 'org'];

  static USER_STATE = ['normal', 'blocked', 'revoked', 'deprecated'];

  static SEARCH_FIELDS = ['userId', 'username', 'nickname', 'email', 'title'];
}
